import { render } from "./Expired.vue?vue&type=template&id=09fda857&scoped=true"
const script = {}

import "./Expired.vue?vue&type=style&index=0&id=09fda857&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/athletics-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fda857"]])

export default __exports__